import React from 'react';
import styles from './CalendarEmptySlot.module.scss';
import classNames from 'classnames';
import { Button } from '@mui/material';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { locales } from '../../constants';

const t = locales.en.components.programs.calendarEmptySlot;

export interface CalendarEmptySlotProps {
  isSelected: boolean;
  isStartDay: boolean;
  onAddWorkout: () => void;
  isDroppable?: boolean;
  isDraggingOver?: boolean;
  className?: string;
}

export const CalendarEmptySlot: React.FC<CalendarEmptySlotProps> = ({
  isSelected,
  isStartDay,
  onAddWorkout,
  isDroppable = false,
  isDraggingOver = false,
  className,
}) => {
  return (
    <div
      className={classNames(
        styles.calendarEmptySlot,
        className,
        {
          [styles.selected]: isSelected,
          [styles.startDay]: isStartDay,
          [styles.droppable]: isDroppable,
          [styles.draggingOver]: isDraggingOver,
        },
      )}
    >
      <div className={styles.slotContainer}>
        <Button className={styles.addButton} onClick={() => onAddWorkout()}>
          <AddBoxOutlinedIcon color="primary" />
          <span className={styles.text}>{t.addWorkout}</span>
        </Button>
      </div>
    </div>
  );
};
